import React, { useEffect, useState } from "react";
import "../../css/components/Home/HomeSeoBlock.css";

/**
 * Bloque editable (título H1 + párrafo) que se muestra sobre el footer,
 * arriba del newsletter. El contenido se administra desde el panel
 * (Configuración → H1 del Home) y se obtiene del backend.
 */
const HomeSeoBlock = () => {
  const [data, setData] = useState(null);

  useEffect(() => {
    let active = true;

    fetch(`${process.env.BASE_URL}/settings/home-h1`)
      .then((res) => (res.ok ? res.json() : null))
      .then((json) => {
        if (active && json) setData(json);
      })
      .catch(() => {
        /* silencioso: si falla, no se muestra el bloque */
      });

    return () => {
      active = false;
    };
  }, []);

  // No renderizar nada si no hay contenido cargado desde el panel.
  if (!data || (!data.home_h1_title && !data.home_h1_paragraph)) {
    return null;
  }

  // Estilos administrables desde el panel (fallback: Barlow Condensed).
  const blockStyle = { fontFamily: `'${data.home_h1_font || "Barlow Condensed"}', sans-serif` };
  // Interlineado opcional: si no se define, manda el line-height del CSS.
  if (data.home_h1_line_height) {
    blockStyle.lineHeight = data.home_h1_line_height;
  }

  // Ancho máximo opcional: controla dónde corta el texto (en lugar de saltos
  // manuales). width:100% + maxWidth => nunca desborda en mobile.
  const contentStyle = data.home_h1_max_width
    ? { width: "100%", maxWidth: data.home_h1_max_width }
    : undefined;

  return (
    <section className="HomeSeoBlock">
      <div className="container">
        <div className="HomeSeoBlock__content" style={contentStyle}>
          {data.home_h1_title && (
            // El HTML viene sanitizado desde el backend (solo etiquetas de formato).
            <h1
              className="HomeSeoBlock__title"
              style={blockStyle}
              dangerouslySetInnerHTML={{ __html: data.home_h1_title }}
            />
          )}
          {data.home_h1_paragraph && (
            // <div> (no <p>) porque el contenido puede traer bloques <p> con
            // su propio interlineado aplicado desde el editor.
            <div
              className="HomeSeoBlock__paragraph"
              style={blockStyle}
              dangerouslySetInnerHTML={{ __html: data.home_h1_paragraph }}
            />
          )}
        </div>
      </div>
    </section>
  );
};

export default HomeSeoBlock;
